document.addEventListener('DOMContentLoaded', () => {
  const root = document.documentElement;

  // --- helpers
  const lock = () => { root.style.overflow = 'hidden'; };
  const unlock = () => { root.style.overflow = ''; };

  const openEl = (el) => { if(!el) return; el.setAttribute('aria-hidden','false'); lock(); };
  const closeEl = (el) => { if(!el) return; el.setAttribute('aria-hidden','true'); unlock(); };

  // --- Mobile menu drawer
  const menu = document.querySelector('[data-ez-drawer]');
  const openMenuBtn = document.querySelector('[data-ez-drawer-open]');
  const closeMenuBtn = document.querySelector('[data-ez-drawer-close]');
  const menuOverlay = document.querySelector('[data-ez-drawer-overlay]');

  openMenuBtn?.addEventListener('click', () => openEl(menu));
  closeMenuBtn?.addEventListener('click', () => closeEl(menu));
  menuOverlay?.addEventListener('click', () => closeEl(menu));

  // --- Cart drawer
  const cart = document.querySelector('[data-ez-cart]');
  const openCartBtns = document.querySelectorAll('[data-ez-cart-open]');
  const closeCartBtn = document.querySelector('[data-ez-cart-close]');
  const cartOverlay = document.querySelector('[data-ez-cart-overlay]');
  const cartBody = document.querySelector('[data-ez-cart-body]');
  const cartTotal = document.querySelector('[data-ez-cart-total]');
  const cartCountEls = document.querySelectorAll('[data-ez-cart-count]');

  async function refreshCart(){
    try{
      const res = await fetch('/cart.js', { credentials:'same-origin' });
      const data = await res.json();

      cartCountEls.forEach(el => {
        el.textContent = data.item_count;
        el.style.display = data.item_count > 0 ? 'inline-flex' : 'none';
      });

      document.querySelectorAll('[data-ez-cart-btn-wrap]').forEach(wrap => {
        wrap.style.display = data.item_count > 0 ? '' : 'none';
      });

      if(cartTotal){
        cartTotal.textContent = (data.total_price/100).toFixed(2).replace('.', ',') + ' €';
      }

      if(cartBody){
        if(!data.items || data.items.length === 0){
          cartBody.innerHTML = '<div style="opacity:.78;font-family:Mako,sans-serif">Votre panier est vide.</div>';
          return;
        }
        cartBody.innerHTML = data.items.map(it => {
          const img = it.image ? it.image : '';
          const price = (it.final_line_price/100).toFixed(2).replace('.', ',') + ' €';
          return `
            <div class="ez-cart__item">
              <img src="${img}" alt="">
              <div>
                <div class="ez-cart__name">${it.product_title}</div>
                <div class="ez-cart__meta">Qté ${it.quantity} · ${price}</div>
              </div>
            </div>
          `;
        }).join('');
      }
    }catch(e){}
  }

  openCartBtns.forEach(btn => btn.addEventListener('click', async (e) => {
    e.preventDefault();
    await refreshCart();
    openEl(cart);
  }));
  closeCartBtn?.addEventListener('click', () => closeEl(cart));
  cartOverlay?.addEventListener('click', () => closeEl(cart));

  document.addEventListener('keydown', (e) => {
    if(e.key === 'Escape'){
      closeEl(menu);
      closeEl(cart);
    }
  });

  refreshCart();
});


// Desktop dropdown click-to-toggle (prevents disappearing when moving mouse)
document.addEventListener('DOMContentLoaded', () => {
  const drop = document.querySelector('.ez-drop');
  if(!drop) return;
  const btn = drop.querySelector('button');
  const menu = drop.querySelector('.ez-drop__menu');

  function setOpen(v){
    if(!btn || !menu) return;
    btn.setAttribute('aria-expanded', v ? 'true' : 'false');
    if(v){
      menu.style.display = 'block';
      drop.classList.add('is-open');
    }else{
      menu.style.display = '';
      drop.classList.remove('is-open');
    }
  }

  btn?.addEventListener('click', (e) => {
    // allow click toggle without following any link
    e.preventDefault();
    const open = btn.getAttribute('aria-expanded') === 'true';
    setOpen(!open);
  });

  document.addEventListener('click', (e) => {
    if(!drop.contains(e.target)){
      setOpen(false);
    }
  });
});
